module.exports = __webpack_public_path__ + "/img/xero-icon.b2a9cfa0ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/xero-icon.svg
// module id = 1400
// module chunks = 0